import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";

import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  FETCH_DASHBOARD_INIT_ACTION,
  FETCH_DASHBOARD_SUCCESS_ACTION,
  FETCH_DASHBOARD_FAIL_ACTION
} from "./action";

var btoa = require("Base64").btoa;
var history = createBrowserHistory();

function* fetchDashboardList() {
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/count`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      // console.log("!!!!!!!!!!!!!!!!!!!!!!count collections", resJSON);
      yield put({
        type: FETCH_DASHBOARD_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_DASHBOARD_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* dashboardActionWatcher() {
  yield takeEvery(FETCH_DASHBOARD_INIT_ACTION, fetchDashboardList);
}
